import React from "react";
import config from "../../src/globs/config";
import environmentVariables from "../../src/globs/utils/get-environment-variables";
import {
  required,
  minLength,
  maxLength,
  number,
  email,
  // showNotification
} from "react-admin";
import { jwtDecode } from "jwt-decode";
export const Papa = require("papaparse/papaparse.min.js");
// export const RUN_TIME_API_ENDPOINT = 'https://lead-retail-production.herokuapp.com/administrator';
// export const RUN_TIME_API_ENDPOINT = 'https://navendor-ic-api-staging.herokuapp.com/administrator';
// export const RUN_TIME_API_ENDPOINT = 'http://localhost:9999/administrator';

export const RUN_TIME_API_ENDPOINT = config.apiContextPath;

export const loginType = environmentVariables.REACT_APP_LOGIN_TYPE;
export const googleRecaptchaKey = environmentVariables.REACT_APP_RECAPTCHA_KEY;
// export const RUN_TIME_API_ENDPOINT = "http://localhost:9999/administrator";
export const CommonHeaderOption = () => {
  const stateData = localStorage.getItem("__state");
  const userData = stateData ? JSON.parse(stateData) : false;
  let options = {};
  if (userData) {
    options = {
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: userData._token,
      }),
    };
  } else {
    options = {
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    };
  }

  return options;
};

export const monthList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const GetCurrentToken = () => {
  const stateData = localStorage.getItem("__state");
  const userData = stateData ? JSON.parse(stateData) : false;
  if (userData) {
    return userData._token;
  }
  return false;
};


export const GetCurrentUserRoles = () => {
  const stateData = localStorage.getItem("__state");
  const userData = stateData ? JSON.parse(stateData) : false;

    const token = GetCurrentToken();
    const decoded = jwtDecode(token);
    console.log('userData', userData);

        const localStorageAppType = localStorage.getItem("app_type");
        console.log(localStorageAppType,"common app stota ")

        document.title = (localStorageAppType === "HOLCIM")
        ? "HOLCIM+ Admin Dashboard"
        : "Clickit Admin Dashboard";

        const favicon = document.getElementById("favicon");

        if (favicon) {
        favicon.href = localStorageAppType === "HOLCIM"
        ? "/favicon2.ico"
        : "/favicon.ico";
        }


    if(userData){
        let roles = []
        // roles.push(userData._roles.name)
        roles.push(decoded.roles.name)
        // for(let i=0;i<userData._roles.length;i++){
        //     roles.push(userData._roles[i]["name"]);
        // }
        return roles;
    }
    return false;
}

export const ComplaintMenu = () => {
  const stateData = localStorage.getItem("__state");
  const userData = stateData ? JSON.parse(stateData) : false;
  // console.log('userData', userData);
  // let complaint = false;
  if (userData.complaint_mgmt) {
    return true;
  }
  return false;
};

export const getLocalStorageKey = (key) => {
  const stateData = localStorage.getItem("__state");
  const userData = stateData && JSON.parse(stateData);
  return userData && userData[key];
};

export const getCurrencySymbol = () => {
  const stateData = localStorage.getItem("__state");
  const userData = stateData && JSON.parse(stateData);
  return userData && userData.currency_symbol;
};

export const getDigitalOrderStatusChoices = () => {
  const choices = [];
  const statusKeyMappings = getLocalStorageKey("order_status_key_mappings");
  if (statusKeyMappings && typeof statusKeyMappings === "object") {
    Object.keys(statusKeyMappings).forEach((statusKey) => {
      choices.push({
        id: Number(statusKey),
        name: statusKeyMappings[statusKey],
      });
    });
  }
  return choices;
};

export const getComplaintTypeChoices = () => {
  const choices = [];
  const complaint_type = getLocalStorageKey("complaint_type");
  complaint_type.map((key) => {
    choices.push({ id: key.comp_type, name: key.comp_type });
  });
  return choices;
};

export const getSubCategoryChoices = () => {
  const choices = [];
  const categoryList = getLocalStorageKey("subcategory_name");
  categoryList.map((key) => {
    // console.log('key is ', key)
    choices.push({ id: key.name, name: key.name });
  });
  console.log("choices >>>>>>", choices);
  return choices;
};

export const getCategoryChoices = () => {
  const choices = [];
  const categoryList = getLocalStorageKey("category_name");
  categoryList.map((key) => {
    // console.log('key is ', key)
    choices.push({ id: key.id, name: key.name });
  });
  console.log("choices >>>>>>", choices);
  return choices;
};

export const getComplaintStatusChoices = () => {
  const choices = [];
  const complaint_status = getLocalStorageKey("complaint_status");
  complaint_status.map((key) => {
    choices.push({ id: key.name, name: key.display_name });
  });
  return choices;
};

export const DigitalOrderSystem = () => {
  const __state = JSON.parse(localStorage.getItem("__state"));
  const digital_order_system = __state.digital_order_system;
  return digital_order_system ? digital_order_system : "";
};

export const validatePhoneNo = [
  required(),
  minLength(10),
  maxLength(15),
  number(),
];

export const validateEmail = [required(), email()];

export const validateSapCode = [
  required(),
  minLength(10),
  maxLength(10),
  number(),
];

export const JSONToCSVConvertor = (JSONData, ReportTitle, ShowLabel) => {
  //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
  var arrData = typeof JSONData !== "object" ? JSON.parse(JSONData) : JSONData;

  var CSV = "";
  //Set Report title in first row or line

  //  CSV += ReportTitle + '\r\n\n';

  //This condition will generate the Label/Header
  if (ShowLabel) {
    var row = "";

    //This loop will extract the label from 1st index of on array
    for (let index in arrData[0]) {
      //Now convert each value to string and comma-seprated
      row += index + ",";
    }

    row = row.slice(0, -1);

    //append Label row with line break
    CSV += row + "\r\n";
  }

  //1st loop is to extract each row
  for (var i = 0; i < arrData.length; i++) {
    var row1 = "";

    //2nd loop will extract each column and convert it in string comma-seprated
    for (let index in arrData[i]) {
      row1 += '"' + arrData[i][index] + '",';
    }

    row1.slice(0, row1.length - 1);

    //add a line break after each row
    CSV += row1 + "\r\n";
  }

  if (CSV === "") {
    alert("Invalid data");
    return;
  }

  //Generate a file name
  var fileName = ReportTitle + "_";
  //this will remove the blank-spaces from the title and replace it with an underscore
  fileName = ReportTitle.replace(/ /g, "_");

  //Initialize file format you want csv or xls
  var uri = "data:text/csv;charset=utf-8," + escape(CSV);

  // Now the little tricky part.
  // you can use either>> window.open(uri);
  // but this will not work in some browsers
  // or you will not get the correct file extension

  //this trick will generate a temp <a /> tag
  var link = document.createElement("a");
  link.href = uri;

  //set the visibility hidden so it will not effect on your web-layout
  link.style = "visibility:hidden";
  link.download = fileName + ".csv";

  //this part will append the anchor tag and remove it after automatic click
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const EmptyPagination = () => {
  return <div></div>;
};

export const myCustomNotification = (message, type = "warning") => {
  // return showNotification(message, type);
};

// export const validateIndianMobileNo = regex(/^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/, 'Must be a valid Indian Mobile No');
